<template>
  <section class="u-bg--teal-90">
    <div :style="landingBanner">
      <div class="mb-12">
        <bl-text-av tag="h1" variation="heading-28" color="inverse" weight="bold" style="display: inline">
          {{ $options.text.title.h1 }}
        </bl-text-av>
        <bl-text-av tag="span" variation="heading-28" color="inverse" weight="bold">
          {{ $options.text.title.other }}
        </bl-text-av>
      </div>

      <bl-text-av class="mb-32" variation="body-16" color="inverse">
        {{ $options.text.subtitle }}
      </bl-text-av>

      <register-button />
    </div>
  </section>
</template>

<script>
/* istanbul ignore file */
import { assetURL } from 'shared/helpers/assetHelper';
import { Header as text } from 'shared/modules/seo/Homepage';
import BlTextAv from '@bukalapak/bazaar-mweb-2/dist/components/BlTextAv';
import RegisterButton from 'seo-mobile/components/RegisterButton';

export default {
  name: 'Header',

  text,

  components: {
    BlTextAv,
    RegisterButton,
  },

  computed: {
    isSSR() {
      return this.$root.isSSR;
    },

    landingBanner() {
      return {
        padding: '40px 16px',
        'background-repeat': 'no-repeat',
        'background-position': 'bottom left',
        'background-image': `url(${assetURL('hero_banner_mobile.png', this.isSSR)})`,
        'background-size': '100%',
        height: '318px',
      };
    },
  },
};
</script>
